import React, { useEffect, useMemo, useState } from 'react';
import { BsChevronLeft, BsChevronRight, BsZoomIn, BsZoomOut } from 'react-icons/bs';
import { pdfjs } from 'react-pdf';
import { Box, Flex, HStack, Icon, IconButton, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../../styles/theme/foundation/colors';
import ChildrenType from '../../../types/ChildrenType';

// TODO: decide which doc viewer to use moving forward
const DocumentViewer = ({ file, maxHeight = '600px', enableZoom = false, leftHeaderChildren = null }) => {
  const url = useMemo(() => file?.preview ?? URL.createObjectURL(file), [file]);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1.5);
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  useEffect(() => {
    setNumPages(null);
    setPageNumber(1);
  }, [file]);

  const onDocumentLoadSuccess = ({ numPages: pageCount }) => {
    setNumPages(pageCount);
    setPageNumber(pageNumber);
  };

  const changePage = offset => {
    setPageNumber(prevPageNumber => prevPageNumber + offset);
  };

  const previousPage = () => changePage(-1);
  const nextPage = () => changePage(1);

  const zoom = offset => setScale(prev => prev + offset);
  const zoomIn = () => zoom(0.5);
  const zoomOut = () => zoom(-0.5);

  const renderPreviewImage = () => {
    if (file.type.includes('image')) {
      return (<img alt="document-preview" src={url} />);
    }

    return (
      <iframe src={url} style={{ height: 'auto', minHeight: '620px', width: '100%' }} title={file.name} />
      // <Box boxShadow="sharp1" justifyContent="center" maxHeight={maxHeight} overflow="auto">
      //   <Document
      //     file={url}
      //     onLoadSuccess={onDocumentLoadSuccess}
      //   >
      //     <Outline onItemClick={({ pageNumber: itemPageNumber }) => setPageNumber(itemPageNumber)} />
      //     <Page pageNumber={pageNumber} renderAnnotationLayer={false} scale={scale} />
      //   </Document>
      // </Box>
    );
  };

  return (
    <>
      {enableZoom
        ? (
          <Flex justifyContent={leftHeaderChildren ? 'space-between' : 'flex-end'} mb={6}>
            {leftHeaderChildren}
            <HStack spacing={4}>
              <IconButton
                aria-label="zoom in"
                icon={<Icon as={BsZoomIn} />}
                isDisabled={scale === 2.5}
                size="sm"
                variant="accent"
                onClick={zoomIn}
              />
              <IconButton
                aria-label="zoom in"
                icon={<Icon as={BsZoomOut} />}
                isDisabled={scale === 1.5}
                size="sm"
                variant="accent"
                onClick={zoomOut}
              />
            </HStack>
          </Flex>
        )
        : (
          <Flex justfiyContent="flex-start" mb={6}>
            {leftHeaderChildren}
          </Flex>
        )}
      {renderPreviewImage()}
      {numPages > 1 && (
      <Flex alignItems="center" justifyContent="center">

        <Flex
          alignItems="center"
          backgroundColor={colors.greyScale['900']}
          borderRadius="lg"
          color="white"
          height="32px"
          justifyContent="space-between"
          maxWidth="130px"
          minW="90px"
          mt={4}
          width="auto"
        >
          <Box width="32px">
            { (pageNumber - 1) > 0 && (
            <IconButton
              aria-label="back"
              icon={<Icon as={BsChevronLeft} />}
              size="sm"
              variant="textWhite"
              onClick={previousPage}
            />
            )}
          </Box>
          <Text textStyle="bodyMd500">{`${pageNumber}/${numPages}`}</Text>
          <Box width="32px">
            { (pageNumber + 1) <= numPages && (
            <IconButton
              aria-label="back"
              icon={<Icon as={BsChevronRight} />}
              size="sm"
              variant="textWhite"
              onClick={nextPage}
            />
            )}
          </Box>
        </Flex>
      </Flex>
      )}
    </>
  );
};

DocumentViewer.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  file: PropTypes.object,
  maxHeight: PropTypes.string,
  leftHeaderChildren: ChildrenType,
  enableZoom: PropTypes.bool
};

export default DocumentViewer;
